// /*
// * Broadcast Theme
// *
// * Use this file to add custom Javascript to Broadcast.  Keeping your custom
// * Javascript in this fill will make it easier to update Broadcast. In order
// * to use this file you will need to open layout/theme.liquid and uncomment
// * the custom.js script import line near the bottom of the file.
// */

/* ------------------------------------------------------------------
 * Desktop scroll fix (Claude, Aug 17 2026)
 *
 * Vertical mouse-wheel scrolling can stall when the cursor sits over a
 * horizontal product carousel (.grid--slider: recently viewed / related
 * products) or the product gallery thumbnail strip. When the wheel
 * gesture is mostly vertical, forward it to the page so the visitor
 * keeps scrolling instead of the carousel swallowing the gesture.
 * Horizontal trackpad swipes over the carousels are untouched.
 * ------------------------------------------------------------------ */
(function () {
  var SELECTOR = '.grid--slider, .product__thumbs__holder';
  var scheduled = false;

  function onWheel(event) {
    // Only intervene when the intent is clearly vertical page scrolling.
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    var dy = event.deltaY;
    if (event.deltaMode === 1) dy *= 40; // lines -> approx px
    else if (event.deltaMode === 2) dy *= window.innerHeight; // pages -> px

    event.preventDefault();
    try {
      window.scrollBy({ top: dy, left: 0, behavior: 'instant' });
    } catch (err) {
      window.scrollBy(0, dy);
    }
  }

  function bind() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].__wheelFixBound) {
        els[i].__wheelFixBound = true;
        els[i].addEventListener('wheel', onWheel, { passive: false });
      }
    }
  }

  function scheduleBind() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      bind();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Carousels rendered later (ajax sections, theme editor, upsells).
  document.addEventListener('shopify:section:load', scheduleBind);
  if ('MutationObserver' in window) {
    new MutationObserver(scheduleBind).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();

/* ------------------------------------------------------------------
 * Loox review pop-up gate (Claude, Aug 30 2026)
 *
 * The Loox review pop-up notification (.loox-pn) is fixed to the
 * bottom-left corner of the viewport. On the single-column mobile
 * layout that corner is exactly where the product H1 and the Loox star
 * rating sit when the page loads, so the pop-up lands on top of the
 * most important text on the page. (At 375x812 the pop-up rests at
 * x10/y605-787; the H1 runs y583-693 and the star rating y695-715.)
 *
 * This keeps the pop-up out of sight until BOTH:
 *   1. a short minimum delay has passed, and
 *   2. its resting box no longer overlaps the product title or rating.
 *
 * On wider layouts the title sits in the right-hand column and there is
 * no overlap, so the pop-up appears as soon as the delay elapses. On
 * mobile it appears once the visitor has scrolled the title clear.
 *
 * Note: Loox parks the pop-up off-canvas with translateX(-120px)
 * between rotations, so its live bounding rect is not where it will
 * actually sit. The zone below is built from the untransformed layout
 * box (computed left / bottom + offset size) instead, and keeps the
 * tallest height seen so far, since the box grows with longer reviews.
 *
 * Fail-safe: the hiding CSS is injected by this script and is scoped to
 * a class this script sets, so if the script never runs the pop-up
 * behaves exactly as it does today. Nothing is permanently suppressed.
 * ------------------------------------------------------------------ */
(function () {
  var MIN_DELAY = 4000; // ms before the pop-up may appear at all
  var MARGIN = 12; // px of breathing room around the title block
  var TITLE_SELECTORS = ['.product__title h1', 'h1', '.loox-rating'];

  var root = document.documentElement;
  var start = Date.now();
  var maxHeight = 0;
  var done = false;
  var timer = null;

  // Injected here (not in the theme stylesheet) so the rule cannot
  // outlive the script that clears it.
  var style = document.createElement('style');
  style.textContent =
    'html.loox-pn-gate:not(.loox-pn-ready) .loox-pn{' +
    'visibility:hidden !important;opacity:0 !important;pointer-events:none !important;}';
  (document.head || root).appendChild(style);
  root.classList.add('loox-pn-gate');

  function restingZone(pn) {
    var cs = window.getComputedStyle(pn);
    if (cs.position !== 'fixed') return null;

    var w = pn.offsetWidth;
    var h = pn.offsetHeight;
    if (!w || !h) return null;

    if (h > maxHeight) maxHeight = h;
    h = maxHeight;

    var left = parseFloat(cs.left);
    if (!isFinite(left)) {
      var right = parseFloat(cs.right);
      left = isFinite(right) ? window.innerWidth - right - w : 0;
    }

    var bottomOffset = parseFloat(cs.bottom);
    if (isFinite(bottomOffset)) {
      var bottomY = window.innerHeight - bottomOffset;
      return { left: left, right: left + w, top: bottomY - h, bottom: bottomY };
    }

    var top = parseFloat(cs.top);
    if (!isFinite(top)) top = 0;
    return { left: left, right: left + w, top: top, bottom: top + h };
  }

  function intersects(a, b) {
    return !(
      a.right <= b.left - MARGIN ||
      b.right + MARGIN <= a.left ||
      a.bottom <= b.top - MARGIN ||
      b.bottom + MARGIN <= a.top
    );
  }

  function blocked(zone) {
    for (var i = 0; i < TITLE_SELECTORS.length; i++) {
      var el = document.querySelector(TITLE_SELECTORS[i]);
      if (!el) continue;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      // Off-screen titles cannot be covered.
      if (r.bottom < 0 || r.top > window.innerHeight) continue;
      if (intersects(zone, r)) return true;
    }
    return false;
  }

  function reveal() {
    done = true;
    root.classList.add('loox-pn-ready');
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    if (timer) clearInterval(timer);
  }

  function check() {
    if (done) return;
    if (Date.now() - start < MIN_DELAY) return;

    var pn = document.querySelector('.loox-pn');
    if (!pn) return; // Loox has not injected it yet.

    var zone = restingZone(pn);
    if (!zone) return;

    if (!blocked(zone)) reveal();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      check();
    });
  }

  timer = setInterval(check, 400);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();